/**
 * Single source of truth for runtime configuration on the client.
 *
 * All values originate from Vite environment variables (prefixed VITE_) so
 * deployment-specific information lives outside source control. The shape
 * of the object is intentionally flat to make consumption straightforward.
 */

const env = import.meta.env;

const config = {
    network: {
        name: env.VITE_NETWORK_NAME || "Base Sepolia",
        chainId: Number(env.VITE_CHAIN_ID || 84532),
        rpcUrl: env.VITE_RPC_URL || "https://sepolia.base.org",
        nativeCurrency: {
            name: env.VITE_NATIVE_SYMBOL || "ETH",
            symbol: env.VITE_NATIVE_SYMBOL || "ETH",
            decimals: 18
        },
        blockExplorerUrl: env.VITE_BLOCK_EXPLORER_URL || "https://sepolia.basescan.org"
    },
    backendUrl: env.VITE_BACKEND_URL || "http://127.0.0.1:4000",
    // WalletConnect cloud project id. Generated at https://cloud.walletconnect.com.
    // Without it the WalletConnect option in the connect modal stays disabled
    // — the SDK refuses to initialise.
    walletConnectProjectId: env.VITE_WALLETCONNECT_PROJECT_ID || "",
    contracts: {
        bond: env.VITE_BOND_ADDRESS || "",
        safeVault: env.VITE_SAFE_VAULT_ADDRESS || "",
        treasury: env.VITE_TREASURY_ADDRESS || "",
        depositNft: env.VITE_DEPOSIT_NFT_ADDRESS || "",
        lending: env.VITE_LENDING_ADDRESS || "",
        turbo: env.VITE_TURBO_ADDRESS || "",
        autoCompound: env.VITE_AUTO_COMPOUND_ADDRESS || "",
        reinvestment: env.VITE_REINVESTMENT_ADDRESS || "",
        gil: env.VITE_GIL_ADDRESS || "",
        tokenBuyRouter: env.VITE_TOKEN_BUY_ROUTER_ADDRESS || "",
        // Uniswap V2 router for the user-facing Buy/Sell $GILD marketplace.
        // Optional: when unset the Marketplace page discovers it on-chain from
        // `tokenBuyRouter.swapRouter()` (the protocol's token-buy leg uses the
        // same router), so this only needs setting to override that lookup.
        uniswapRouter: env.VITE_UNISWAP_ROUTER_ADDRESS || "",
        usdc: env.VITE_USDC_ADDRESS || "",
        tvt: env.VITE_TVT_ADDRESS || "",
        priceBandExecutor: env.VITE_PRICE_BAND_EXECUTOR_ADDRESS || "",
        treasuryExecutor: env.VITE_TREASURY_EXECUTOR_ADDRESS || "",
        marketingEngine: env.VITE_MARKETING_ENGINE_ADDRESS || "",
        selfPayingNetting: env.VITE_SELF_PAYING_NETTING_ADDRESS || "",
        dePegGuard: env.VITE_DEPEG_GUARD_ADDRESS || "",
        governance: env.VITE_GOVERNANCE_ADDRESS || ""
    },
    protocol: {
        usdcDecimals: 6,
        minDepositUsdc: 100,
        annualRateBps: 2000,
        fixedTermDays: 1095,
        earlyExitPenaltyBps: 2000,
        safeVaultBps: 8000,
        maxLtvBps: 7500,
        liquidationThresholdBps: 8500,
        loanAprBps: 1500,
        autoCompoundTriggerUsdc: 100
    },
    restrictedRegions: ["US", "SG",]
};

export default config;
